import { render, staticRenderFns } from "./system-simulation-refund.vue?vue&type=template&id=679b21f2&scoped=true"
import script from "./system-simulation-refund.vue?vue&type=script&lang=js"
export * from "./system-simulation-refund.vue?vue&type=script&lang=js"
import style0 from "./system-simulation-refund.vue?vue&type=style&index=0&id=679b21f2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679b21f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('679b21f2')) {
      api.createRecord('679b21f2', component.options)
    } else {
      api.reload('679b21f2', component.options)
    }
    module.hot.accept("./system-simulation-refund.vue?vue&type=template&id=679b21f2&scoped=true", function () {
      api.rerender('679b21f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/develop-manage/system-simulation-refund.vue"
export default component.exports